import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-text-box-holder', {
    position: 'relative',
    height: '23px',
});

cssRule('.tb-text-box-border', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    padding: '1px 7px',
});

cssRule('.tb-text-box-border:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-text-box-border.tb-clearable', {
    paddingRight: '23px',
});

cssRule('.tb-text-box-border.tb-disabled, .tb-text-box-border.tb-disabled:hover', {
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-placeholder::-webkit-input-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-placeholder::-moz-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-placeholder:-moz-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-placeholder:-ms-input-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-text-box-input', {
    width: '100%',
    margin: 0,
    padding: 0,
    border: 0,
    outline: 0,
    /* error: '-moz-box-shadow': 'none', */
    '-webkit-box-shadow': 'none',
    boxShadow: 'none',
    height: '19px',
    lineHeight: '19px',
    marginLeft: '-6px',
    marginRight: '-6px',
    paddingLeft: '6px',
    paddingRight: '6px',
    color: 'inherit',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    verticalAlign: 'top',
    fontSize: '12px',
    fontFamily: 'inherit',
});

cssRule('.tb-text-box-input::-webkit-input-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-text-box-input::-moz-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-text-box-input:-moz-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-text-box-input:-ms-input-placeholder', {
    fontStyle: 'italic',
});

cssRule('.tb-text-box-input::-ms-clear', {
    display: 'none',
});

cssRule('.tb-clear-button', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '23px',
    lineHeight: '23px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '-1px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
});

cssRule('.tb-clear-button:hover', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-clear-button-icon', {
    backgroundImage: 'url(img/widget_small_close.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
});

cssRule('.tb-clear-button-icon:hover', {
    backgroundImage: 'url(img/widget_small_close_active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('label.placeholder', {
    fontStyle: 'italic !important',
});

cssRule('.tb-multiline-text-holder', {
    padding: '7px',
});

cssRule('.tb-react-multiline-text-holder', {
    padding: '3px',
});

cssRule('.tb-multiline-text', {
    width: '100%',
    height: '100px',
    resize: 'vertical',
    margin: '-7px',
    padding: '6px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    outline: 0,
    fontSize: '12px',
    fontFamily: 'inherit',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-multiline-text:hover, .tb-multiline-text:focus', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

